import { createContext, useContext } from 'react';

/**
 * Separate from ChatProvider + lazy ChatPanel to avoid a circular dependency:
 * ChatContext.jsx lazy-imports ChatPanel, which must read the same context object.
 */
export const ChatPanelContext = createContext(null);

export function useChatPanel() {
    const ctx = useContext(ChatPanelContext);
    if (!ctx) {
        throw new Error('useChatPanel must be used within ChatProvider');
    }
    return ctx;
}

/** Safe hook when ChatProvider is optional (e.g. tests) */
export function useChatPanelOptional() {
    return useContext(ChatPanelContext);
}
